
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 7.5l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10l-8-4m8 4v10m-8-14v10l8 4","stroke":"currentColor","stroke-width":"1.5","stroke-linejoin":"round"}})])
          )
        }
      }
    